import { render, staticRenderFns } from "./dataMenu.vue?vue&type=template&id=1cffe43c&scoped=true&"
import script from "./dataMenu.vue?vue&type=script&lang=js&"
export * from "./dataMenu.vue?vue&type=script&lang=js&"
import style0 from "./dataMenu.vue?vue&type=style&index=0&id=1cffe43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffe43c",
  null
  
)

export default component.exports